import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationHandlerService, TranslatedToastrService, EditComponent, BaseComponent, LanguageService, AdminToVestraUsersEmailModel } from 'lib/Vestra.shared';
import { AdminToVestraUsersResultModel, CoreService, SystemParameterType, VestraUserService } from 'src/app/services/api-services';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { VestraUserSelectComponent } from '../../../../vestra-user/vestra-user-select/vestra-user-select.component';
import { VestraUserSelectType } from 'src/app/services/api-services';
import beautify from 'js-beautify';
import { NotificationResultComponent } from '../../notification-result/notification-result.component';
declare var $: any;
@Component({
    selector: 'app-notification-create-email',
    templateUrl: './notification-create-email.component.html',
    styleUrls: ['./notification-create-email.component.scss'],
})
export class NotificationCreateEmailComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;

    @ViewChild(VestraUserSelectComponent)
    vestraUserSelectComponent: VestraUserSelectComponent;
    public vestraUserSelectType: VestraUserSelectType = VestraUserSelectType.Email;
    public title: string;
    public form: FormGroup;
    public isLargeScreen: boolean = false;
    public maxFileAttachment: number;


    private subscription: Subscription;
    public selectedFiles: File[] = [];

    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        private translatedToastrService: TranslatedToastrService,
        private translateService: TranslateService,
        protected override modalService: BsModalService,
        private coreService: CoreService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
        private vestraUserService: VestraUserService,
        private responsive: BreakpointObserver
    ) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }
    get hasAttachment(): boolean
    {
        return this.selectedFiles.length > 0;
    }
    private selectedUserIds: number[] = [];

    public ngAfterViewInit(): void {
        this.initSummerNote();
    }
    public initSummerNote() {
        console.log("start")
        $('#summernote').summernote({
            height: 200,
            tooltip: true,
            tabsize: 2,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'picture', 'video', 'table']],
                ['view', ['codeview', 'help']],
            ],
            callbacks: {
                onChange: (contents: string) => {
                    this.form.controls['message'].setValue(contents);
                },
                onBlurCodeview: () => {
                    let codeContents = $('#summernote').summernote('code');
                    this.form.controls['message'].setValue(codeContents);
                },
            },
        });

        this.setSummerNoteValue();
    }


    public ngOnInit() {
        this.subscription = this.responsive.observe(Breakpoints.WebLandscape).subscribe(result => {
            this.isLargeScreen = false;

            if (result.matches) {
                this.isLargeScreen = true;
            }
        });
        this.handleSpinner(
            firstValueFrom(this.coreService.getSystemParameterById(SystemParameterType.MaxEmailFileAttachment))
                .then(res => {
                    const parsedValue = parseInt(res.result.value);
                    this.maxFileAttachment = !isNaN(parsedValue) ? parsedValue : 3;
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
        this.init();
    }

    public async init() {
        this.form = new FormGroup({
            subject: new FormControl('', [Validators.required]),
            message: new FormControl('', [Validators.required]),
        });
    }
    public changeSelectedUserIds(event: any) {
        this.selectedUserIds = [...event];
    }
    public sendNotification = async (isAllVestraUsersSelected: boolean): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            if ($('.note-editable')[0].innerText != '' && $('.note-editable')[0].innerText != '\n')
            {
                this.checkAndSaveBodyValue(this.form.get('message')?.value);
                let itemToSave = this.form.getRawValue();
                itemToSave.message = this.cleanHtml(this.form.get('message')?.value)


                let adminToVestraUsersEmailModel = {} as AdminToVestraUsersEmailModel;

                adminToVestraUsersEmailModel.subject = itemToSave.subject;
                adminToVestraUsersEmailModel.message = itemToSave.message;
                adminToVestraUsersEmailModel.attachmentList = <any>this.selectedFiles;


                if (isAllVestraUsersSelected) {
                    adminToVestraUsersEmailModel.allSelected = true;
                } else {
                    adminToVestraUsersEmailModel.allSelected = false;
                    adminToVestraUsersEmailModel.receiverVestraUserIds = this.selectedUserIds;
                }
                const isNotSelected: boolean = !adminToVestraUsersEmailModel.allSelected && adminToVestraUsersEmailModel.receiverVestraUserIds.length === 0;
                if (isNotSelected) {
                    this.translatedToastrService.warning('common.vestra_user_select_warning', 'common.warning');
                    return;
                }
                return this.handleSpinner(
                    firstValueFrom(this.vestraUserService.adminSendEmailToVestraUsers(adminToVestraUsersEmailModel as AdminToVestraUsersEmailModel))
                        .then(res => {
                            if (res.isSuccess) {
                                this.showNotificationResult(res.result);
                                this.selectedUserIds = [];
                                this.vestraUserSelectComponent.userIds = [];
                                this.vestraUserSelectComponent.refreshDataTable();
                            } else {
                                this.translatedToastrService.warning(res.message, 'common.warning');
                            }
                            return Promise.resolve(res);
                        })
                        .catch((err: HttpErrorResponse) => {
                            this.validationHandlerService.handleServerError(err, this.form);
                        })
                );
            }
        }
    };
    public onSendNotification(type: any) {
        let itemToSave = this.form.getRawValue();

        switch (type) {
            case 1:
                this.openConfirmDialog(itemToSave?.subject, () => this.sendNotification(false), null, 'common.send_confirm_title', 'common.send_confirm_message');
                break;
            case 2:
                this.openConfirmDialog(itemToSave?.subject, () => this.sendNotification(true), null, 'common.send_confirm_title', 'common.send_confirm_message');
                break;
            default:
                break;
        }
    }
    getFileSize(size: number): string {
        if (size === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    public removeFile(index: number): void {
        if (index > -1 && index < this.selectedFiles.length) {
            this.selectedFiles.splice(index, 1);
            this.translatedToastrService.success('notification.email_attachment_removed_successfully','common.success');
        }
    }

    public addFile(input: HTMLInputElement) {
        const files = input.files;

        if (files && files.length > 0) {
            const totalCountAfterAdd = this.selectedFiles.length + files.length;
            
            if (totalCountAfterAdd > this.maxFileAttachment) {
                this.translatedToastrService.warning(
                    'notification.email_max_attachments_num', 
                    'common.warning', 
                    null, 
                    this.maxFileAttachment.toString()
                );
            
                input.value = ''; 
                return; 
            }
            for (let i = 0; i < files.length; i++) {
                this.selectedFiles.push(files[i]);
            }

            this.translatedToastrService.success('notification.email_attachment_add_successfully', 'common.success');
            input.value = ''; 
        }
    }


    //#region  Private functions
    private showNotificationResult(adminToVestraUsersResultModel: AdminToVestraUsersResultModel) {
        if (adminToVestraUsersResultModel) {
            let modalOptions: ModalOptions = this.getDefaultModalOptions('notification.result_title', adminToVestraUsersResultModel);
            let bsModalRef: BsModalRef = this.modalService.show(NotificationResultComponent, modalOptions);
        }
    }
    private checkAndSaveBodyValue(bodyValue: string) {
        const containsDoctype = bodyValue.includes('<!DOCTYPE html>');
        const containsMetaTags = bodyValue.includes('<meta charset="utf-8"');

        let cleanedBody = bodyValue;
        if (containsMetaTags) {
            cleanedBody = cleanedBody.replace(/<meta[^>]*>/gi, '');
        }

        if (!containsDoctype) {
            let updatedBodyValue = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="utf-8" />
                    <meta http-equiv="x-ua-compatible" content="IE=edge">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                </head>
                <body>
                    ${cleanedBody}
                </body>
                </html>
            `;

            this.form.controls['message'].setValue(updatedBodyValue);
        }
    }

    private cleanHtml(bodyValue: string): string {
        let cleanedBodyValue = bodyValue
            .replace(/\n+/g, '')
            .replace(/\r+/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();

        return cleanedBodyValue;
    }
    private setSummerNoteValue() {
        let formattedHtml = beautify.html(this.form.get('message').value, {
            indent_size: 2,
            preserve_newlines: true,
            wrap_line_length: 120,
        });

        $('#summernote').summernote('code', formattedHtml);
    }
}
